/*******************************************************
 *  Llamando a las constante para la autenticación
 *  
 *******************************************************/

const state = {
    identity: null,
    token: null,
    user:JSON.parse(localStorage.getItem('user'))||null,
}
/*******************************************************
 * * Obteniendo y guardando las autenticaciones para el token
 *  
 *******************************************************/

const getters = {
    getIdentity: state => state.identity,
    getToken: state => state.token
}

const actions = {
    saveIdentity({ state, commit }, identity) {
        commit('identity', identity)
    },

    saveToken({state, commit}, token) {
        commit('token', token)
    }
}

const mutations = {
    identity(state, identity) {
        state.identity = identity
    },

    token(state, token){
        state.token = token
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}